import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

@Component({
  components: { DsModal, DatePicker },
})
export default class AccountConnectMetasearchComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @Prop({ type: Array, required: false }) sourceCacheList!: any;

  showModal = this.open;
  isDisable = true;
  formData = {
    keyword: [''],
    dateRange: [null, null],
    limit: 5,
  };

  isShowDatePicker = false;
  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
    this.formData = {
      keyword: [''],
      dateRange: [null, null],
      limit: 5,
    };
    if (this.sourceCacheList.length > 0) {
      console.log(this.sourceCacheList, 'sourceCacheList');
      const matchedChannel = this.sourceCacheList.find(channel => channel.channelType === 'MS_TOPIC');

      if (matchedChannel) {
        const dataSources = matchedChannel.accounts[0].dataSource;
        dataSources.forEach(ds => {
          if (ds.dataSourceTypes[0] === 'KEYWORD') {
            this.formData.keyword = ds.value;
          }
        });
      }
    }
  }
  @Watch('formData.keyword')
  onCheck(value: any) {
    if (value.length === 1) {
      this.isDisable = value[0].trim() === '';
    } else if (value.length > 1) {
      this.isDisable = value.every(key => key.trim() === '');
    } else {
      this.isDisable = true;
    }
  }

  get filterDatePickerLabel() {
    return this.formData.dateRange?.[0] && this.formData.dateRange?.[1]
      ? `${this.formData.dateRange[0]} ~ ${this.formData.dateRange[1]}`
      : 'Choose a Period';
  }
  handleAddMoreKeyword() {
    this.formData.keyword.push('');
  }
  handleRemoveKeyword(item: any, index: any) {
    this.formData.keyword.splice(index, 1);
  }

  handleAddMetasearchItem() {
    const cleanData = this.formData.keyword.filter(item => item.trim() !== '');
    const data: any = {
      keyword: cleanData,
      dateRange: this.formData.dateRange,
      limit: this.formData.limit,
    };

    console.log('Metasearch data submitted:', data);
    this.$emit('handleAddMetasearchItem', data);
    this.$emit('modal:close');
  }

  disableFutureDates(date) {
    return date > new Date();
  }

  toggleDatePicker() {
    console.log('Toggle date picker, current state:', this.isShowDatePicker);
    this.isShowDatePicker = !this.isShowDatePicker;
  }

  mounted() {
    // Add event listener for clicks outside the date picker
    document.addEventListener('click', this.handleDocumentClick);
  }

  beforeDestroy() {
    // Remove event listener when component is destroyed
    document.removeEventListener('click', this.handleDocumentClick);
  }

  handleDocumentClick(event: Event) {
    const datepickerPopup = this.$refs.datepickerPopup as HTMLElement;
    const datePickerButton = event.target as HTMLElement;

    // Check if the click is outside the date picker and not on the toggle button
    if (
      this.isShowDatePicker &&
      datepickerPopup &&
      !datepickerPopup.contains(datePickerButton) &&
      !datePickerButton.closest('.go-btn-dropdown')
    ) {
      this.isShowDatePicker = false;
    }
  }
}
